export default __webpack_public_path__ + "static/media/1260.0c01f7d1.png";